import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import add from '../Images/add-square.png';
import leftArrowIcon from '../Images/right.png';
import rightArrowIcon from '../Images/left.png';

const ProductCard = ({ product }) => (
  <div className="flex flex-col items-start bg-white rounded-lg shadow-lg mx-6 md:mx-2 my-2 cursor-pointer">
  <div className="w-full">
    <img src={product.image} alt={product.name} className="w-full mb-4"
      style={{
        backgroundSize: 'contain', 
        backgroundPosition: 'center', 
        backgroundRepeat: 'no-repeat', 
        aspectRatio: '16 / 14',
      }}
    />
  </div>
  <div className="text-start pl-5 flex flex-col justify-between h-[150px]">
    <h3 className="text-md mb-2" style={{ fontFamily: 'arial' }}>{product.name}</h3>
    <p className="text-xs mr-2 mb-7" style={{ fontFamily: 'arial', color: '#8C8C8C' }}>{product.description}</p>
    <div className="flex flex-row items-center justify-between mb-5 gap-10">
      <p className=" " style={{ fontFamily: 'arial', fontSize: '13px' }}>From £{product.min_price}</p>
      <div className="flex flex-row items-center gap-2 ">
        <p style={{ color: '#EC008C', fontFamily: 'arial', fontSize: '13px' }}>
          Shop Now
        </p>
        <button>
          <img src={add} className="w-4 h-4 mr-2" alt="Add" />
        </button>
      </div>
    </div>
  </div>
</div>
);

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const carouselRef = useRef(null);

  useEffect(() => {
    axios
      .get('https://backend.printtrio.co.uk/api/category/get-category')
      .then((res) => {
        if (res.data.success) {
          const sortedCategories = res.data.data
            .filter(cat => cat.is_active === 1)
            .sort((a, b) => a.ordering - b.ordering); // Sort by ordering ascending
          setCategories(sortedCategories.slice(0, 8));
        }
      })
      .catch((err) => console.error(err));
  }, []);
  

  const scrollPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.clientWidth,
        behavior: 'smooth',
      });
    }
  };
  const scrollNext = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.clientWidth,
        behavior: 'smooth',
      });
    }
  };

  const handleCategoryClick = (id, name, banner, desc) =>
    navigate('/Category-name', {
      state: { categoryId: id, categoryName: name, banner, description: desc, scrollToPromo: true },
    });

  const handleSeeAllClick = () => {
    axios
      .get('https://backend.printtrio.co.uk/api/category/get-category')
      .then((res) => {
        if (res.data.success) {
          const c = res.data.data[0];
          navigate('/categories', {
            state: {
              banner: c.banner,
              name: c.name,
              description: c.description,
            },
          });
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="bg-white py-12 px-4 md:px-16 xl:px-48 max-w-screen-2xl mx-auto">
      <h2 className="text-2xl md:text-4xl xl:text-5xl font-semibold mb-14 text-center" style={{ fontFamily: 'arial', color: '#191919' }}>
        Categories
      </h2>

      {/* ── Mobile carousel ── */}
{/* <div className="relative sm:hidden">
  <button
    onClick={scrollPrev}
    className="absolute -left-2 top-1/2 transform -translate-y-1/2 z-10 p-0"
  >
    <img src={leftArrowIcon} alt="Previous" className="w-6 h-6" />
  </button>

  <div
    ref={carouselRef}
    className="flex overflow-x-auto scroll-smooth snap-x snap-mandatory px-0 py-6"
  >
    {categories.map(cat => (
      <div
        key={cat.id}
        className="snap-start flex-shrink-0 w-full"
        onClick={() =>
          handleCategoryClick(cat.id, cat.name, cat.banner, cat.description)
        }
      >
        <ProductCard product={cat} />
      </div>
    ))}
  </div>

  <button
    onClick={scrollNext}
    className="absolute -right-4 top-1/2 transform -translate-y-1/2 z-10 p-2"
  >
    <img src={rightArrowIcon} alt="Next" className="w-6 h-6" />
  </button>
</div> */}


      {/* ── Desktop grid ── */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {categories.map((cat) => (
          <div
            key={cat.id}
            onClick={() =>
              handleCategoryClick(cat.id, cat.name, cat.banner, cat.description)
            }
          >
            <ProductCard product={cat} />
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <button
          className="px-6 py-3 bg-pink-500 text-white font-semibold rounded-full"
          onClick={handleSeeAllClick}
        >
          See All
        </button>
      </div>
    </div>
  );
};

export default Categories;
